<style>
  form {
    display: inline-block;
    height: auto;
    border-radius: 10px;
    margin-top: 3rem;
    padding: 2rem;
    position: relative;
  }
  .exit {
    position: absolute;
    top: -0.5rem;
    left: -0.5rem;
    background: black;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    color: white;
    cursor: pointer;
  }
</style>
<script>
  import {getToken} from "../js-core/conn/auth/auth-main"

  let success, errOccured, uploadLoading
  let uploadPic = async () => {
    uploadLoading = true
    success = false
    errOccured = false
    const fileElem = document.querySelector("#picFile");
    const contentType = "image/png";
    const formData = new FormData();
    formData.append("file", fileElem.files[0]);
    formData.append("contentType", contentType);
    formData.append("filename", fileElem.value);
    const res = await BSFetch("tv-owner/profile-pic", {
      method: "POST",
      headers: {
        authorization: getToken()
      },
      body: formData,
      mode: "cors",
      cache: "no-cache"
    });
    if (res.status === 201) {
      errOccured = false
      uploadLoading = false
      success = true
      location.reload()
    } else {
      errOccured = true
    }
  }
  export let isOpen = false
</script>
<div class="full-screen translucent-bckgrnd center-content" style="align-items: baseline;">
  <form on:submit={(e) => {e.preventDefault(); uploadPic()}}>
    <div class="exit" on:click={() => { isOpen=false }}>X</div>
    <p>
      Select the image which you would like to upload as a profile picture
    </p>
    <div class="form-group">
      <div class="custom-file">
        <input type="file" class="" id="picFile" accept="image/png" required/>
      </div>
    </div>
    <div class="form-group">
      <button type="submit" class="main btn btn-primary {uploadLoading ? 'loading' : ''}">
        Submit Profile Picture
      </button>
    </div>
    {#if success}
      <p>Your profile picture has been successfully uploaded</p>
    {:else if errOccured}
      <p>
        An error occured while uploading your profile picture
      </p>
    {/if}
  </form>
</div>